import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import PropTypes from 'prop-types';

import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import * as Actions from 'store/actions';
import { Button, Typography, FormControl, Select, MenuItem } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';

const styles = theme => ({
    layoutRoot: {},
    pagingPeringkat: {
        textAlign: 'right'
    }
});

class PilihSekolah extends Component {
    state = {
        error:0,
        open: true,
        routeParams: {
            pengguna_id: JSON.parse(localStorage.getItem('user')).pengguna_id,
            token: localStorage.getItem('jwt_token')
        },
        value: JSON.parse(localStorage.getItem('user')).sekolah_id,
        fullWidth: true,
        maxWidth: 'lg'
    }

    goTolink = (url) => {
        this.props.history.push(url);
    };

    componentDidMount = () => {
        console.log(JSON.parse(localStorage.getItem('user')).sekolah_id);
        // this.props.setJudul('Rapor Mutu');
        this.props.getSekolahBinaan(this.state.routeParams).then((result)=>{
            console.log(this.props.sekolah_binaan);
        });
    }

    handleClose = () => {
        // this.setState({
        //     open: false
        // });

        // window.location.href=localStorage.getItem('root_base');
    }

    handleCloseButton = () => {
        // this.setState({
        //     open: false
        // });

        window.location.href=localStorage.getItem('root_base');
    }

    onChangeSekolahBinaan = (e) => {
        // this.props.getSekolahBinaan(this.state.routeParams);
        // alert(e.target.value);
        let user = JSON.parse(localStorage.getItem('user'));
        user.sekolah_id = e.target.value;
        // console.log(user);

        localStorage.setItem('user',JSON.stringify(user));
        localStorage.setItem('sekolah_id_pengawas',e.target.value);

        this.setState({
            value: e.target.value
        });

        console.log(localStorage.getItem('user'));
    }

    render()
    {
        const {classes, fullScreen} = this.props;
        
        return (
            <Dialog
                onClose={this.handleClose}
                aria-labelledby="customized-dialog-title"
                open={this.props.dialog_sekolah_binaan}
                fullWidth={this.state.fullWidth}
                maxWidth={this.state.maxWidth}
                fullScreen={fullScreen}
                style={{marginLeft:'10px',marginRight: '10px'}}
            >
                <DialogTitle id="customized-dialog-title" onClose={this.handleClose}>
                    Pilih sekolah binaan yang akan Anda isi kuesionernya
                </DialogTitle>
                <DialogContent>
                    <FormControl variant="outlined" className={classes.formControl} style={{width: '100%'}}>
                        <Select
                            value={this.state.value}
                            onChange={this.onChangeSekolahBinaan}
                            style={{color: '#434343'}}
                        >
                            {this.props.sekolah_binaan.map((option)=>{
                                return (<MenuItem value={option.sekolah_id}><Typography variant="body1"><b>{option.nama} ({option.npsn})</b><br/><span style={{fontSize:'11px'}}>{option.kecamatan}, {option.kabupaten}, {option.provinsi}</span></Typography></MenuItem>)
                            })}
                            {/* <MenuItem value="2018"><Typography variant="body1">Sekolah A (NPSN) - Kecamatan, Kabupaten, Provinsi</Typography></MenuItem> */}
                            {/* <MenuItem value="2019"><Typography variant="body1">Sekolah B (NPSN) - Kecamatan, Kabupaten, Provinsi</Typography></MenuItem> */}
                        </Select>
                    </FormControl>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleCloseButton} color="primary">
                        Pilih Sekolah
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }

}

PilihSekolah.propTypes = {
    fullScreen: PropTypes.bool.isRequired
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getSekolah: Actions.getSekolah,
        setKunciKonfirmasiInstrumen: Actions.setKunciKonfirmasiInstrumen,
        getKonfirmasiSelesai: Actions.getKonfirmasiSelesai,
        getKemajuanTotal: Actions.getKemajuanTotal,
        getPeringkatPengisian: Actions.getPeringkatPengisian,
        setLoading: Actions.setLoading,
        setJudul: Actions.setJudul,
        getSekolahBinaan: Actions.getSekolahBinaan,
        setDialogSekolahBinaan: Actions.setDialogSekolahBinaan
    }, dispatch);
}

function mapStateToProps({ Sekolah, Instrumen, App }) {

    return {
        sekolah: Sekolah.sekolah,
        konfirmasi_instrumen_id: Instrumen.konfirmasi_instrumen_id,
        konfirmasi_instrumen: Instrumen.konfirmasi_instrumen,
        kemajuan_total: Instrumen.kemajuan_total,
        peringkat_pengisian: Instrumen.peringkat_pengisian,
        sekolah_binaan: Sekolah.sekolah_binaan,
        dialog_sekolah_binaan: App.dialog_sekolah_binaan
    }
}

// export default withStyles(styles, {withTheme: true})(Beranda);
export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(PilihSekolah)));



// WEBPACK FOOTER //
// ./src/main/content/example/PilihSekolah.js